import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useClient } from '../../../context/ClientStatusContext';
import { getPouzivatelskaSkupinaBySearchToken } from '../../../client/ldapSearchDataClient';
import LdapItem from '../../../model/LdapItem';

type ReturnType = [
  ldapData: LdapItem[],
  isFetched: boolean,
];

const longerThan3chars = (string: string): boolean => string.length >= 3;

const useSearchPouzivatelskaSkupina = (searchString: string): ReturnType => {
  const [, setAction] = useState(null);
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { wrapClient, data } = useClient(getPouzivatelskaSkupinaBySearchToken);
  const [finished, setFinished] = useState<boolean>(false);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
    });
    setFinished(false);
    if (searchString && longerThan3chars(searchString.trim())) {
      const act = setTimeout(async () => {
        await wrapClient(type, year, index, searchString.trim());
        setFinished(true);
      }, 300);

      setAction(act);
    }
  }, [index, searchString, type, wrapClient, year]);

  return [data, finished];
};

export default useSearchPouzivatelskaSkupina;
